import { FetcherResponse } from "src/api/fetch";

export const getDataFromResponse = <T>(response: FetcherResponse<T>, defaultValue: T): T => {
  return response.status === 'success' ? response.data : defaultValue;
};
